const adminConfig = {
    startPage: "/assignments/manage",
    settingsAccess: true,
    menuModules: [
        "Assignments"
    ]
};

const userConfig = {
    startPage: "/assignments",
    settingsAccess: false,
    menuModules: [
        "Assignments"
    ],
};




export const permissionDefinition = {
    "Admin": adminConfig,
    "None": userConfig
};
